import logitravelPricesDesktopStyles from "./styles/logitravel.js";
import partnershipsPricesDesktopStyles from "./styles/partnerships.js";
import partnershipsPortaventuraPricesDesktopStyles from "./styles/portaventura.js";
import smyPricesDesktopStyles from "./styles/smy.js";
import veciPricesDesktopStyles from "./styles/veci.js";
const pricesDesktopThemes = {
    logitravel: logitravelPricesDesktopStyles,
    partnerships: partnershipsPricesDesktopStyles,
    partnershipsPortaventura: partnershipsPortaventuraPricesDesktopStyles,
    smy: smyPricesDesktopStyles,
    veci: veciPricesDesktopStyles
};
export default pricesDesktopThemes;

//# sourceMappingURL=index.js.map